(function () {
  "use strict";

  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("mt-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll("[data-mt-contador]");
    if (!els.length) return;
    var animado = new WeakSet();
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || animado.has(entry.target)) return;
          animado.add(entry.target);
          var el = entry.target;
          var fin = parseFloat(el.getAttribute("data-mt-contador")) || 0;
          var decimales = (el.getAttribute("data-mt-decimales") || "0") === "1" ? 1 : 0;
          var duracion = 1400;
          var inicio = null;
          function paso(ts) {
            if (!inicio) inicio = ts;
            var progreso = Math.min((ts - inicio) / duracion, 1);
            var facil = 1 - Math.pow(1 - progreso, 3);
            var valor = fin * facil;
            el.textContent = decimales ? valor.toFixed(1) : Math.round(valor);
            if (progreso < 1) requestAnimationFrame(paso);
            else el.textContent = decimales ? fin.toFixed(1) : fin;
          }
          requestAnimationFrame(paso);
        });
      },
      { threshold: 0.6 }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initCarruselResenas() {
    var carruseles = document.querySelectorAll("[data-mt-carrusel]");
    carruseles.forEach(function (carrusel) {
      var pista = carrusel.querySelector("[data-mt-pista]");
      var puntos = carrusel.querySelectorAll("[data-mt-punto]");
      var prev = carrusel.querySelector("[data-mt-prev]");
      var next = carrusel.querySelector("[data-mt-next]");
      if (!pista) return;
      var tarjetas = pista.children.length;
      var indice = 0;

      function ir(i) {
        indice = (i + tarjetas) % tarjetas;
        var tarjeta = pista.children[indice];
        pista.scrollTo({ left: tarjeta.offsetLeft - pista.offsetLeft, behavior: "smooth" });
        puntos.forEach(function (p, idx) { p.classList.toggle("mt-activo", idx === indice); });
      }
      if (prev) prev.addEventListener("click", function () { ir(indice - 1); });
      if (next) next.addEventListener("click", function () { ir(indice + 1); });
      puntos.forEach(function (p, idx) {
        p.addEventListener("click", function () { ir(idx); });
      });
    });
  }

  function initSelectorVariantes() {
    var forms = document.querySelectorAll("[data-mt-producto-form]");
    forms.forEach(function (form) {
      var dataEl = form.querySelector("[data-mt-variantes-json]");
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var contenedor = form.closest("[data-mt-producto-contenedor]") || form;
      var inputId = form.querySelector("input[name='id']");
      var precioEl = contenedor.querySelector("[data-mt-precio]");
      var precioTachadoEl = contenedor.querySelector("[data-mt-precio-tachado]");
      var botonComprar = form.querySelector("[data-mt-boton-comprar]");
      var opciones = form.querySelectorAll("[data-mt-opcion]");

      function formatoDinero(centavos) {
        return (centavos / 100).toLocaleString(document.documentElement.lang || "es", {
          style: "currency",
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "EUR",
        });
      }

      function seleccionActual() {
        return Array.prototype.map.call(opciones, function (grupo) {
          var activo = grupo.querySelector(".mt-swatch--activo, .mt-opcion-valor--activo");
          return activo ? activo.getAttribute("data-valor") : null;
        });
      }

      function encontrarVariante() {
        var seleccion = seleccionActual();
        return variantes.find(function (v) {
          return v.options.every(function (op, idx) { return op === seleccion[idx]; });
        });
      }

      function actualizar() {
        var variante = encontrarVariante();
        if (!variante) return;
        if (inputId) inputId.value = variante.id;
        if (precioEl) precioEl.textContent = formatoDinero(variante.price);
        if (precioTachadoEl) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioTachadoEl.textContent = formatoDinero(variante.compare_at_price);
            precioTachadoEl.style.display = "";
          } else {
            precioTachadoEl.style.display = "none";
          }
        }
        if (botonComprar) {
          if (variante.available) {
            botonComprar.disabled = false;
            botonComprar.textContent = botonComprar.getAttribute("data-texto-disponible") || botonComprar.textContent;
          } else {
            botonComprar.disabled = true;
            botonComprar.textContent = botonComprar.getAttribute("data-texto-agotado") || "Agotado";
          }
        }
        var idParam = variante.featured_image ? variante.featured_image.id : null;
        if (idParam) {
          var miniatura = document.querySelector('[data-mt-miniatura-media="' + idParam + '"]');
          if (miniatura) miniatura.click();
        }
      }

      opciones.forEach(function (grupo) {
        var etiquetaActual = grupo.querySelector("[data-mt-opcion-actual]");
        grupo.querySelectorAll("[data-valor]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            grupo.querySelectorAll("[data-valor]").forEach(function (b) {
              b.classList.remove("mt-swatch--activo", "mt-opcion-valor--activo");
            });
            btn.classList.add(btn.classList.contains("mt-swatch") ? "mt-swatch--activo" : "mt-opcion-valor--activo");
            if (etiquetaActual) etiquetaActual.textContent = btn.getAttribute("data-valor");
            actualizar();
          });
        });
      });

      actualizar();
    });
  }

  function initGaleriaProducto() {
    var galerias = document.querySelectorAll("[data-mt-galeria]");
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector("[data-mt-imagen-principal]");
      var miniaturas = galeria.querySelectorAll("[data-mt-miniatura-media]");
      if (!principal) return;
      miniaturas.forEach(function (mini, idx) {
        mini.addEventListener("click", function () {
          var src = mini.getAttribute("data-full");
          if (!src) return;
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = src;
            principal.style.opacity = 1;
          }, 120);
          miniaturas.forEach(function (m) { m.classList.remove("mt-miniatura--activa"); });
          mini.classList.add("mt-miniatura--activa");
          galeria.setAttribute("data-mt-indice-actual", idx);
        });
      });
    });
  }

  function initNivelesCantidad() {
    var grupos = document.querySelectorAll("[data-mt-niveles-cantidad]");
    grupos.forEach(function (grupo) {
      var form = grupo.closest("form");
      if (!form) return;
      var cantidadInput = form.querySelector("[data-mt-cantidad]");
      var niveles = grupo.querySelectorAll("[data-mt-nivel]");
      niveles.forEach(function (nivel) {
        nivel.addEventListener("click", function () {
          niveles.forEach(function (n) { n.classList.remove("mt-nivel-cantidad--activo"); });
          nivel.classList.add("mt-nivel-cantidad--activo");
          if (cantidadInput) cantidadInput.value = nivel.getAttribute("data-mt-nivel");
        });
      });
    });
  }

  function initLightboxProducto() {
    var galerias = document.querySelectorAll("[data-mt-galeria]");
    galerias.forEach(function (galeria) {
      var lightbox = galeria.parentElement ? galeria.parentElement.querySelector("[data-mt-lightbox]") : null;
      if (!lightbox) return;
      var dataEl = lightbox.querySelector("[data-mt-lightbox-json]");
      var fotos = [];
      try { fotos = JSON.parse((dataEl && dataEl.textContent) || "[]"); } catch (e) { fotos = []; }
      if (!fotos.length) return;

      var imgEl = lightbox.querySelector("[data-mt-lightbox-imagen]");
      var contadorEl = lightbox.querySelector("[data-mt-lightbox-contador]");
      var abrirBtn = galeria.querySelector("[data-mt-abrir-lightbox]");
      var principal = galeria.querySelector("[data-mt-imagen-principal]");
      var cerrarBtn = lightbox.querySelector("[data-mt-lightbox-cerrar]");
      var prevBtn = lightbox.querySelector("[data-mt-lightbox-prev]");
      var nextBtn = lightbox.querySelector("[data-mt-lightbox-next]");
      var indice = 0;

      function mostrar(i) {
        indice = (i + fotos.length) % fotos.length;
        imgEl.src = fotos[indice].src;
        imgEl.alt = fotos[indice].alt || "";
        if (contadorEl) contadorEl.textContent = (indice + 1) + " / " + fotos.length;
      }

      function abrir() {
        var actual = parseInt(galeria.getAttribute("data-mt-indice-actual"), 10) || 0;
        mostrar(actual);
        lightbox.style.display = "flex";
        lightbox.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
      }

      function cerrar() {
        lightbox.style.display = "none";
        lightbox.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      }

      if (abrirBtn) abrirBtn.addEventListener("click", abrir);
      if (principal) principal.addEventListener("click", abrir);
      if (cerrarBtn) cerrarBtn.addEventListener("click", cerrar);
      if (prevBtn) prevBtn.addEventListener("click", function () { mostrar(indice - 1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { mostrar(indice + 1); });
      lightbox.addEventListener("click", function (e) {
        if (e.target === lightbox) cerrar();
      });
      document.addEventListener("keydown", function (e) {
        if (lightbox.style.display !== "flex") return;
        if (e.key === "Escape") cerrar();
        if (e.key === "ArrowLeft") mostrar(indice - 1);
        if (e.key === "ArrowRight") mostrar(indice + 1);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initContadores();
    initCarruselResenas();
    initSelectorVariantes();
    initNivelesCantidad();
    initGaleriaProducto();
    initLightboxProducto();
  });
})();
